import React from "react";
import { toColumnLabel } from "../../utils/columnUtils";
// Import the FOLDER component explicitly — "../FilterMenu" would resolve
// to the legacy FilterMenu.js file (files beat folders), which carries no
// CSS and left the dropdown unstyled (items flowed horizontally).
import FilterMenu from "../FilterMenu/FilterMenu";

/**
 * ColumnHeader
 * Single `<th>` in the table's thead — shows the column letter (A, B,
 * AA, ...), the filter icon, an optional dropdown filter popup, and a
 * drag handle for resizing.  Sticky-left positioning is added by the
 * caller when the column is part of the frozen pane.
 */
function ColumnHeader({
  colIndex, colWidth, className, style,
  isFiltered, isFilterMenuOpen, filterRows,
  currentFilter, onToggleFilter, onApplyFilter, onCloseFilter,
  onClick, onContextMenu, onStartResize,
}) {
  return (
    <th
      className={className}
      style={style}
      onClick={onClick}
      onContextMenu={onContextMenu}
    >
      {toColumnLabel(colIndex)}
      <span
        className={`filter-excel-btn ${isFiltered ? "filtered" : ""}`}
        onClick={(e) => onToggleFilter(colIndex, e)}
        title="Filter"
      >
        {isFiltered ? (
          <span className="material-icons" style={{ fontSize: "13px" }}>filter_alt</span>
        ) : (
          <span className="material-icons" style={{ fontSize: "15px" }}>arrow_drop_down</span>
        )}
      </span>
      {isFilterMenuOpen && (
        <FilterMenu
          colIndex={colIndex}
          rows={filterRows}
          currentFilter={currentFilter}
          onApply={(sel) => onApplyFilter(colIndex, sel)}
          onClose={onCloseFilter}
        />
      )}
      <span className="col-resize-handle" onMouseDown={(event) => onStartResize("col", colIndex, event)} />
    </th>
  );
}

export default React.memo(ColumnHeader);
